import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { ClickEventListener } from '@philips-emr/tws-core/lib/component/types';

export default class HpmsTermCheckboxAPI extends ComponentAPI<any> {

  @AwesomeEvent
  onClickLink = new ClickEventListener();

  @AwesomeEvent
  onClickCheckBox = new ClickEventListener();

  setChecked(check: boolean): void {
    this.setState({ check });
  }

  isChecked(): boolean {
    return this.state.check || false;
  }

  setEnabled(enabled: boolean): void {
    this.setState({ enabled });
  }

  isEnabled(): boolean {
    return this.state.enabled;
  }
}
